import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
  RedirectRequest,
} from "@azure/msal-browser";

// Browser check variables
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

// Validate required env vars
const clientId = process.env.REACT_APP_CLIENT_APP_ID;
if (!clientId) {
  throw new Error("Missing REACT_APP_CLIENT_APP_ID in environment variables");
}

// MSAL Configuration
export const msalConfigAzureAd: Configuration = {
  auth: {
    clientId: clientId,
    authority: "https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com/",
    //authority: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906/",
    redirectUri: window.location.origin,
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge, // Use cookies for legacy browser compatibility
    cacheLocation: BrowserCacheLocation.LocalStorage, // Store tokens in localStorage
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (!containsPii) {
          console.log(`[MSAL][${LogLevel[level]}]: ${message}`);
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

// Example request configuration for accessing MS Graph.
export const graphLoginRequest: RedirectRequest = {
  scopes: ["https://graph.microsoft.com/User.Read.All"],
  domainHint: "exxonmobil.com",
  prompt: "login",
};

// Place any scopes required by your app here
export const appLoginRequestAzure: RedirectRequest = {
  scopes: [],
  //domainHint: "exxonmobil.com",
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

/**
 * Note: Configuration for scopes, api endpoints and client ids can be
 * configured in whichever way feels the most natural and accessible way
 *  for you and your applications use-case. Please feel free to abstract them
 *  away from this file in whichever way you see fit.
 */
